<template>
  <div class="progressbar-container">
    <svg class="progressbar center-block" :width="full_length">
      <line class="total" x1="5%" y1="50%" x2="95%" y2="50%" />
      <line class="progress" x1="5%" y1="50%" :x2="progress_percentage" y2="50%" />
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      full_length: Number,
      percentage_complete: Number,
    },
    computed: {
      progress_percentage () {
        return `${this.percentage_complete * 0.9 + 5}%`
      }
    },
  }
</script>
